module.exports = __webpack_public_path__ + "mo/img/piece-02.b2039344.svg";